<template>
    <ul v-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <a v-if="item.href" :href="item.href" target="_blank" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </a>
                <router-link v-else :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div :class="className + '__link gnb__link--toggle d-xl-none'">
                    <h2>{{ item.title }}</h2>
                </div>
                <a v-if="item.href" :href="item.href" target="_blank" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </a>
                <router-link v-else :to="item.path" :class="className + '__link d-none d-xl-flex'">
                    <h2>{{ item.title }}</h2>
                </router-link>

                <div :class="className + '__sub'">
                    <v-row no-gutters justify="center" class="no-wrap">
                        <v-col v-for="child in item.children" cols="12" xl="2" :key="child.title">
                            <div :class="className + '__sub-inner'">
                                <a v-if="child.href" :href="child.href" target="_blank" :class="className + '-sub__link'">
                                    <h2>{{ child.title }}</h2>
                                </a>
                                <router-link v-else :to="child.path" :class="className + '-sub__link'">
                                    <h2>{{ child.title }}</h2>
                                </router-link>

                                <v-row no-gutters align="center">
                                    <v-col cols="12" v-if="child?.children?.length">
                                        <ul :class="className + '__sub2'">
                                            <template v-for="grandChild in child.children">
                                                <li v-if="!grandChild.children" :key="grandChild.title">
                                                    <a v-if="grandChild.href" :href="grandChild.href" target="_blank" :class="className + '-sub2__link'">{{ grandChild.title }}</a>
                                                    <router-link v-else :to="grandChild.path" :class="className + '-sub2__link'">{{ grandChild.title }}</router-link>
                                                </li>
                                            </template>
                                        </ul>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </li>
        </template>
    </ul>
    <!-- <ul v-else-if="className == 'slide-gnb'" :class="className">
        <template v-for="item in gnbs">
            <li :class="className + '__li'" :key="item.title">
                <router-link :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>
        </template>
    </ul> -->
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
    },
    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "기업소개",
                    path: "/about#about",
                    children: [
                        {
                            title: "비전과 미션",
                            path: "/about#about-vision",
                        },
                        {
                            title: "대표인사말",
                            path: "/about#about-greeting",
                        },
                        {
                            title: "연혁",
                            path: "/about#about-history",
                        },
                        {
                            title: "CI/BI",
                            path: "/about#about-cibi",
                        },
                        {
                            title: "기술인증 현황",
                            path: "/about#about-technology",
                            children: [
                                {
                                    title: "특허",
                                    path: "/about#about-patent",
                                },
                                {
                                    title: "인증",
                                    path: "/about#about-certification",
                                },
                                {
                                    title: "상표/디자인",
                                    path: "/about#about-trademark",
                                },
                                {
                                    title: "수상",
                                    path: "/about#about-award",
                                },
                            ],
                        },
                    ],
                },
                {
                    title: "비즈니스",
                    path: "/business#business",
                    children: [
                        {
                            title: "비즈니스 로드맵",
                            path: "/business#business-roadmap",
                        },
                        {
                            title: "스마트팜 제품 솔루션",
                            path: "/business#business-solution",
                        },
                        {
                            title: "스마트팜 시설",
                            path: "/business#business-facility",
                        },
                        {
                            title: "작물재배",
                            path: "/business#business-crop",
                        },
                        {
                            title: "유통 서비스",
                            path: "/business#business-distribution",
                        },
                    ],
                },
                {
                    title: "핵심경쟁력",
                    path: "/technology#technology",
                    children: [
                        {
                            title: "핵심기술",
                            path: "/technology#technology-core",
                        },
                        {
                            title: "전문인력 포진",
                            path: "/technology#technology-expert",
                        },
                        {
                            title: "연구센터 및 재배시설",
                            path: "/technology#technology-facility",
                        },
                    ],
                },
                {
                    title: "솔루션",
                    path: "/solution/smartfarm/rmfarm#rmfarm",
                    children: [
                        {
                            title: "팜이레 스마트 팜",
                            path: "/solution/smartfarm/rmfarm#rmfarm",
                            children: [
                                {
                                    title: "알엠팜 고급형",
                                    path: "/solution/smartfarm/rmfarm#rmfarm",
                                },
                                {
                                    title: "알엠팜 기본형",
                                    path: "/solution/smartfarm/rmfarm#rmfarm",
                                },
                                {
                                    title: "알엠팜 보급형",
                                    path: "/solution/smartfarm/rmfarm#rmfarm",
                                },
                                {
                                    title: "파밍온",
                                    path: "/solution/smartfarm/farmingon#farmingon",
                                },
                                {
                                    title: "파밍온2",
                                    path: "/solution/smartfarm/farmingon#farmingon2",
                                },
                                // {
                                //     title: "노지 스마트팜",
                                //     path: "/solution/smartfarm/ground",
                                // },
                                {
                                    title: "스마트 관수제어",
                                    path: "/solution/smartfarm/irrigation",
                                },
                            ],
                        },
                        {
                            title: "팜이레 식물공장",
                            path: "/solution/plant/led",
                            children: [
                                {
                                    title: "LED 시스템",
                                    path: "/solution/plant/led",
                                },
                                {
                                    title: "재배대 시스템",
                                    path: "/solution/plant/rearing",
                                },
                                {
                                    title: "식물공장 통합관제 시스템",
                                    path: "/solution/plant/control",
                                },
                            ],
                        },
                        {
                            title: "AI 빅데이터",
                            path: "/solution/bigdata",
                        },
                    ],
                },
                {
                    title: "커뮤니티",
                    path: "/community/notice",
                    children: [
                        {
                            title: "공지사항",
                            path: "/community/notice",
                        },
                        {
                            title: "미디어",
                            path: "/community/magazine",
                        },
                        // {
                        //     title: "IR",
                        //     path: "/community/ir",
                        // },
                        {
                            title: "문의하기",
                            path: "/community/inquire",
                        },
                        {
                            title: "제품 카탈로그",
                            path: "/community/catalog",
                        },
                    ],
                },
                // {
                //     title: "팜이레몰",
                //     href: "http://shopire.kr",
                // },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function() {},
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>
